import api from "../../../../services/api";

import type { LeadWhatsAppConversation } from "../../../common/whatsapp-conversation/types";

interface ConversationQuery {
  companyId: number | string;
  companyType: string;
  leadResponseId: number;
  conversationId?: number | null;
  beforeId?: number | null;
  limit?: number;
}

const scopePayload = (companyId: number | string, companyType: string) => ({
  signature: localStorage.getItem("signature"),
  company_id: Number(companyId),
  company_type: companyType,
});

export const fetchLeadWhatsAppConversation = async ({
  companyId,
  companyType,
  leadResponseId,
  conversationId,
  beforeId,
  limit,
}: ConversationQuery): Promise<LeadWhatsAppConversation> => {
  const response = await api.post("leadService/whatsappConversation/getByLead", {
    ...scopePayload(companyId, companyType),
    lead_response_id: leadResponseId,
    ...(conversationId ? { conversation_id: conversationId } : {}),
    ...(beforeId ? { before_id: beforeId } : {}),
    ...(limit ? { limit } : {}),
  });
  return response.data.message[0].data;
};

export const markWhatsAppConversationRead = async (
  companyId: number | string,
  companyType: string,
  conversationId: number,
): Promise<void> => {
  await api.post("leadService/whatsappConversation/markRead", {
    ...scopePayload(companyId, companyType),
    conversation_id: conversationId,
  });
};
